<template>
  <div class="col-12 p-0">
    <CCard class="col-12 tablet-bg-8 mx-auto card--custom">
      <CCardBody>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home"
              type="button"
              role="tab"
              aria-controls="home"
              aria-selected="true"
              v-on:click="handleTab"
            >
              Nuevo
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
              v-on:click="handleTab"
            >
              Mis autos
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="card-header mb-4 mt-0 pb-0">
              <h5 class="mb-4 mt-3">
                <span class="text-primary--custom mr-2">
                  <i class="fas fa-file-alt"></i> </span
                >Información general
              </h5>
            </div>
            <div class="d-flex flex-wrap">
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Inicio de la vigencia</label>
                <input type="date" class="form-control" />
              </div>
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Fin de la vigencia</label>
                <input type="date" class="form-control" />
              </div>
              <div class="form-group col-2 cel-6 tablet-sm-3">
                <label for="">Hora</label>
                <input type="number" class="form-control" />
              </div>
              <div class="form-group col-2 cel-6 tablet-sm-3">
                <label for="">Minuto</label>
                <input type="number" class="form-control" />
              </div>
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Descuento</label>
                <select name="" class="form-control" id=""></select>
              </div>
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Paquete</label>
                <select name="" class="form-control" id=""></select>
              </div>
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Estado</label>
                <select name="" class="form-control" id=""></select>
              </div>
            </div>

            <div class="card-header mb-4 mt-4 pb-0">
              <h5 class="mb-4">
                <span class="text-primary--custom mr-2">
                  <i class="fas fa-truck-pickup"></i> </span
                >Datos de tu auto
              </h5>
            </div>
            <div class="d-flex flex-wrap">
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Tipo de vehículo</label>
                <select name="" class="form-control" id=""></select>
              </div>
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Año</label>
                <select name="" class="form-control" id=""></select>
              </div>
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Marca</label>
                <select name="" class="form-control" id=""></select>
              </div>
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Modelo</label>
                <select name="" class="form-control" id=""></select>
              </div>
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Versión</label>
                <select name="" class="form-control" id=""></select>
              </div>
            </div>

            <div class="card-header mb-4 pb-0 mt-4">
              <h5 class="mb-4">
                <span class="text-primary--custom mr-2"
                  ><i class="fas fa-user"></i
                ></span>
                Datos del conductor
              </h5>
            </div>
            <div class="d-flex flex-wrap">
              <div class="form-group col-4 tablet-sm-8 tablet-bg-5">
                <label for="">Fecha de nacimiento</label>
                <div class="d-flex align-items-center">
                  <input
                    type="text"
                    class="form-control col-3 cel-3 tablet-sm-3 tablet-bg-3"
                    placeholder="DD"
                  />
                  <p class="ml-1 mr-1 mt-0 mb-0">/</p>
                  <input
                    type="text"
                    class="form-control col-3 cel-3 tablet-sm-3 tablet-bg-3"
                    placeholder="MM"
                  />
                  <p class="ml-1 mr-1 mt-0 mb-0">/</p>
                  <input type="text" class="form-control" placeholder="AAAA" />
                </div>
              </div>
              <div class="form-group col-4 tablet-sm-4 tablet-bg-3">
                <label for="">C.P.</label>
                <input type="number" class="form-control" />
              </div>
              <div class="form-group col-4 tablet-sm-6 tablet-bg-4">
                <label for="">Sexo</label>
                <select name="" class="form-control" id=""></select>
              </div>
              <div class="form-group col-4 tablet-sm-6">
                <label for="">Tipo de estacionamiento</label>
                <select name="" class="form-control" id=""></select>
              </div>
            </div>

            <div class="col-12 mt-4 d-flex justify-content-end">
              <div
                class="
                  form-group
                  d-flex
                  justify-content-end
                  col-3
                  tablet-sm-12
                  p-0
                "
              >
                <button class="btn btn-primary--custom flex-grow-1">
                  Cotizar
                </button>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div class="table-responsive">
              <table class="table mt-3">
                <thead>
                  <th>Auto</th>
                  <th>Vigencia</th>
                  <th>Paquete</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Nissan versa 2021</td>
                    <td>02/02/2020, 08:26</td>
                    <td>Premium</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { handleTabs } from "../../assets/helpers";

export default {
  methods: {
    handleTab(e) {
      handleTabs(e);
    },
  },
};
</script>